<template>
  <vs-popup
    :title="titlePopUp"
    :active.sync="activatingPopUp"
    @close="closeWithLoad(false)"
    class="p-5"
  >
    <section class="mt-0">
      <vs-collapse accordion type="border">
        <vs-collapse-item>
          <div slot="header">
            <strong>{{ itemEdit !== null ? "Edit Item" : "Tambah Item" }}</strong>
          </div>
          <main class="w-full">
            <div class="mb-6">
              <section class="mb-4 flex justify-start gap-1">
                <h6><strong>Nama Syarat</strong></h6>
                <span class="text-danger">*</span>
              </section>
              <vs-input
                v-validate="'required'"
                data-vv-validate-on="blur"
                name="name"
                class="w-full sidebar-input"
                v-model="formData.name"
                placeholder="Isi Dengan Nama Syarat"
              />
              <span class="text-danger text-sm">{{ errors.first("name") }}</span>
            </div>
            <div class="mb-6">
              <section class="mb-4 flex justify-start gap-1">
                <h6><strong>Deskripsi</strong></h6>
                <span class="text-danger">*</span>
              </section>
              <vs-textarea
                v-validate="'required'"
                data-vv-validate-on="blur"
                name="description"
                class="w-full sidebar-input"
                v-model="formData.deskripsi"
                placeholder="Isi Dengan Deskripsi Syarat"
              />
              <span class="text-danger text-sm">{{ errors.first("description") }}</span>
            </div>
          </main>
          <footer class="mt-4">
            <div class="flex justify-end items-center mr-4 mb-4">
              <vs-button
                v-if="itemEdit !== null"
                color="danger"
                class="mr-2 rounded-2xl"
                @click="closeEdit"
                >Cancel</vs-button
              >
              <vs-button
                color="success"
                class="ml-2 rounded-2xl"
                :disabled="!validateSyarat"
                @click="addSyarat"
                >{{ labelButton }}</vs-button
              >
            </div>
          </footer>
        </vs-collapse-item>
      </vs-collapse>
    </section>
    <section class="mt-4">
      <header class="w-full">
        <div class="mb-base vx-row justify-between items-top">
          <section class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 sm:w-full flex justify-start">
            <span class="text-black text-lg"><strong>Tabel Syarat</strong></span>
          </section>
          <!-- <section
              class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 sm:w-full flex justify-end"
            >
              <vs-button @click="openPopUp(null)" v-if="access.create === 1"
                >Tambah Kategori SOS</vs-button
              >
            </section> -->
        </div>
        <div class="vx-row justify-between items-center">
          <section class="mb-base vx-col md:w-2/5 lg:w-2/5 xl:w-2/5 sm:w-full">
            <div class="w-full gap-2 flex justify-start items-center">
              <vs-button @click="actionsDelete">{{
                selected.length === 0 ? "Hapus" : `Hapus ${selected.length} Item`
              }}</vs-button>
            </div>
          </section>
          <section class="mb-base vx-col md:w-3/5 lg:w-3/5 xl:w-3/5 sm:w-full">
            <div class="w-full flex justify-end gap-2 flex-wrap items-center">
              <vs-input v-model="search" placeholder="Search..." />
            </div>
          </section>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <div
          class="flex flex-wrap items-center justify-between ag-grid-table-actions-right"
        ></div>
      </header>

      <main ref="loadSyarat">
        <vs-table stripe :data="syarats" v-model="selected" max-items="10" multiple>
          <template slot="thead">
            <vs-th>Nama Syarat</vs-th>
            <vs-th>Aksi</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].name">
                {{ data[indextr].name }}
              </vs-td>
              <vs-td>
                <div
                  class="flex justify-start gap-2"
                  v-if="itemDelete !== data[indextr].id"
                >
                  <vs-button
                    color="primary"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-edit"
                    @click="openEdit(data[indextr])"
                  >
                  </vs-button>
                  <vs-button
                    color="danger"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-trash"
                    @click="itemDelete = data[indextr].id"
                  >
                  </vs-button>
                </div>
                <div class="flex justify-start gap-2" v-else>
                  <vs-button
                    color="danger"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-trash"
                    @click="deleteItem(data[indextr].id)"
                  >
                    Delete
                  </vs-button>
                  <vs-button
                    color="#949494"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-x"
                    @click="itemDelete = null"
                  >
                    No
                  </vs-button>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </main>
      <footer>
        <div class="justify-end mt-2">
          <vs-pagination :total="totalPage" v-model="currentPg"></vs-pagination>
        </div>
      </footer>
    </section>
  </vs-popup>
</template>
<script>
import emptyImage from "@/assets/images/elements/empty.png";
import url from "@/url.js";

export default {
  props: {
    activate: { type: Boolean, default: false },
    passData: { type: Object, default: null },
  },
  data() {
    return {
      url,
      emptyImage,
      itemEdit: null,
      params: {},
      search: "",
      itemDelete: null,
      selected: [],
      pagination: {
        start: 0,
        length: 10,
      },
      currentPg: 1,
      tableList: [
        "vs-th: Component",
        "vs-tr: Component",
        "vs-td: Component",
        "thread: Slot",
        "tbody: Slot",
        "header: Slot",
      ],
      syarats: [],
      formData: {
        name: "",
        sub_id: null,
        deskripsi: "",
      },
    };
  },
  computed: {
    totalPage() {
      let pages = this.$store.state.sos.totalSyaratRecords / 10;
      let number = Math.floor(pages);
      if (pages <= 1.0) {
        return 1;
      }

      return number + 1;
    },
    titlePopUp() {
      return this.passData !== null ? `Slot Syarat Dari ${this.passData.name}` : "";
    },
    labelButton() {
      return this.itemEdit != null ? "Edit" : "Submit";
    },
    validateSyarat() {
      return (
        !this.errors.any() &&
        this.formData.name !== "" &&
        this.formData.sub_id !== null &&
        this.formData.deskripsi !== ""
      );
    },
    activatingPopUp: {
      get() {
        return this.activate;
      },
      set(val) {
        this.$emit("callback", val);
      },
    },
  },
  watch: {
    activate() {
      if (this.passData !== null) {
        this.formData.sub_id = this.passData.id;
        this.getSyarat();
      } else {
        this.formData.sub_id = null;
        this.resetForm();
      }
    },
    search() {
      if (this.search !== "") {
        this.params = {
          filter: "name",
          search: this.search,
        };
      } else {
        this.params = {};
      }

      this.getSyarat();
    },
    totalPage() {
      if (this.currentPg > this.totalPage) {
        this.currentPg = this.totalPage;
      }
    },
    limit() {
      this.pagination.length = 10;
      this.getSyarat();
    },
    currentPg() {
      this.pagination.start = this.currentPg <= 1 ? 0 : this.currentPg * 10 - 10;
      this.getSyarat();
    },
  },
  methods: {
    resetForm() {
      this.formData.name = "";
      this.formData.deskripsi = "";
    },
    closeWithLoad(load) {
      this.activatingPopUp = false;
      this.$emit("withClose", load);
    },
    openEdit(val) {
      this.formData.name = val.name;
      this.formData.deskripsi = val.deskripsi;
      this.itemEdit = val;
    },
    closeEdit() {
      this.formData.name = "";
      this.formData.deskripsi = "";
      this.itemEdit = null;
    },
    actionsDelete() {
      if (this.selected.length === 0) {
        this.$vs.notify({
          title: "Tidak ada item yang dipilih",
          text: "Pilihlah salah satu item atau semua item",
          color: "danger",
          position: "top-right",
        });
      } else {
        for (let i in this.selected) {
          this.deleteItem(this.selected[i].id);
        }
      }
    },
    deleteItem(id) {
      this.$vs.loading({
        color: "primary",
      });
      this.closeEdit();
      const fungsi = {
        fungsi: 1,
      };
      this.$store
        .dispatch("sos/cudSyaratSOS", [Object.assign(fungsi, { id: id })])
        .then((v) => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: "top-right",
            title: "Menghapus Sukses!",
            text: `Syarat SOS ${v.name} Berhasil dihapus`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });
          this.selected = [];
          this.getSyarat();
          this.itemDelete = null;
        })
        .catch((e) => {
          this.$vs.loading.close();
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    getSyarat() {
      this.$vs.loading({
        color: "primary",
      });
      this.$store
        .dispatch("sos/getSyaratSOS", {
          ...this.params,
          sub_id: this.formData.sub_id,
          ...this.pagination,
        })
        .then((v) => {
          this.syarats = v.data;
        })
        .catch((e) => {
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    addSyarat() {
      this.$vs.loading({
        color: "primary",
      });
      let id = {};
      if (this.itemEdit !== null) {
        id = {
          id: this.itemEdit.id,
        };
      }
      this.$store
        .dispatch("sos/cudSyaratSOS", [{ ...this.formData, ...id }])
        .then((v) => {
          this.$vs.notify({
            position: "top-right",
            title:
              this.itemEdit !== null
                ? "Edit Syarat SOS Sukses!"
                : "Tambah Syarat SOS Sukses!",
            text:
              this.itemEdit !== null
                ? `Syarat SOS ${v.name} Berhasil diedit`
                : `Syarat SOS ${v.name} Berhasil ditambah`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });
          this.getSyarat();
        })
        .catch((e) => {
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        })
        .finally(() => {
          this.selected = [];
          this.$vs.loading.close();
          this.resetForm();
          this.closeEdit();
        });
    },
  },
};
</script>

<style scoped>
.text-red {
  color: red;
}
.text-blue {
  color: blue;
}
.text-grey-black {
  color: rgb(70, 70, 70);
}
img {
  max-height: 400px;
  overflow: auto;
}
</style>
